export function sanitizeDecimalValue(value: string | number | undefined | null): number | undefined {
  if (typeof value !== 'string') {
    return Number(value);
  }

  let normalizedValue = value.replace(/[\s\u00A0]/g, '');

  // Check if comma is used as decimal separator (French format)
  // French: comma followed by 1-2 digits at end, with no period present
  // if user inputs a period and then a comma, this is considered a faulty user error
  const isFrenchFormat = /,\d{1,2}$/.test(normalizedValue) && !normalizedValue.includes('.');

  if (isFrenchFormat) {
    normalizedValue = normalizedValue.replace(',', '.');
  } else {
    // US format: remove commas (thousands separators)
    normalizedValue = normalizedValue.replace(/,/g, '');
  }

  const result = parseFloat(normalizedValue);
  return isNaN(result) ? undefined : result;
}
